<template>
  <div class="reset-login">
    <el-dialog class="new-ui new-ui-dialog dialog-reset-login" :visible.sync="userPhone.show" width="500px" title="登录已过期，请重新登录" @close="close">
      <div class="dialog-containter">
        <el-form ref="form" :model="userPhone" class="zd-css" label-width="80px" @submit.native.prevent>
          <span><span style="font-weight:700;">快速登录</span>可能造成<span style="color:#F56C6C;">原页面内容缺失</span>或<span style="color:#F56C6C;">最新功能/权限缺失</span>，可根据实际情况进行页面手动刷新；</span>
          <el-form-item label="验证码：" prop="code" :rules="setRule('验证码不能为空')" style="margin-top:10px">
            <div class="el-input el-input--mini el-input-group el-input-group--append el-input--suffix" style="width: 80%;">
              <input v-model="userPhone.code" type="text" placeholder="请输入验证码" class="el-input__inner">
              <div class="el-input-group__append">
                <el-button :disabled="codeLoading" @click="sendKeepLoginCode">{{ codeNumber=== 0 ? '发送验证码' : codeNumber + 's' }}</el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="loading" @click="nativeLogin">返回登录页</el-button>
        <el-button :loading="loading" type="primary" @click="loginNotInWhiteList">快速登录</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { sendKeepLoginCode, checkIP } from '@/api/user'
import { setToken } from '@/utils/auth'
import { deepClone } from '@/utils'

export default {
  name: 'ResetLogin',
  data() {
    return {
      loading: false,
      userPhone: {
        show: false,
        code: ''
      },
      sI: null,
      codeLoading: false,
      codeNumber: 0 // 验证码倒计时
    }
  },
  watch: {
    '$store.getters.loginInfoDialog': {
      handler(show) {
        if (show) {
          this.userPhone.show = true
          this.userPhone.code = ''
        }
      },
      deep: true
    }
  },
  created() {

  },
  methods: {
    setRule(message, type = 'string', rule) {
      const valid = [{ type: type, required: true, message: message }]
      if (rule === 'number') {
        valid.push(
          { validator: (rule, value, callback) => {
            if (!Number.isInteger(Number(value))) {
              callback(new Error('请输入数字值'))
            } else {
              callback()
            }
          }, trigger: 'blur' }
        )
      }

      return valid
    },
    sendKeepLoginCode() {
      if (this.codeNumber > 0) return false
      this.codeLoading = true
      // 发送验证码
      sendKeepLoginCode({ user_id: this.$store.getters.uid, refresh_token: localStorage.getItem('x-refresh-token') }).then(response => {
        // 倒计时60S
        this.codeLoading = false
        this.codeNumber = 60
        this.sI = null
        clearInterval(this.sI)
        this.sI = setInterval(() => {
          this.codeNumber -= 1
          if (this.codeNumber === 0) {
            clearInterval(this.sI)
          }
        }, 1000)
      }).finally(() => {
        this.codeLoading = false
      })
    },
    async loginNotInWhiteList() {
      this.$refs.form.validate(async(valid) => {
        if (!valid) {
          return
        }
        this.loading = true
        checkIP({
          code: this.userPhone.code
        }).then(async(response) => {
          setToken(response.data.token, response.data.refresh_token)
          this.$message.success('登录成功')
          this.userPhone.show = false

          try {
            const data = await this.$store.dispatch('user/getInfo')
            // generate accessible routes map based on roles
            const accessRoutes = deepClone(await this.$store.dispatch('permission/generateRoutes', data))
            // dynamically add accessible routes
            // resetRouter() 有动态路由，不可用
            // 删除无效标签
            this.delView(accessRoutes)
            const banner = this.$store.getters.timerObject['unBannerTimer']
            if (banner) {
              banner.fn()
              this.$store.dispatch('timer/init', { name: banner.name, fn: banner.fn, time: banner.time }).catch(reason => {
                console.log(reason)
              })
            }
            const readTimer = this.$store.getters.timerObject['unReadTimer']
            if (readTimer) {
              readTimer.fn()
              this.$store.dispatch('timer/init', { name: readTimer.name, fn: readTimer.fn, time: readTimer.time }).catch(reason => {
                console.log(reason)
              })
            }
          } catch (error) {
            this.$message.error('获取权限出错')
          }
        }).finally(() => {
          this.loading = false
        })
      })
    },
    delView(accessRoutes) {
      let accessRoutesPath = accessRoutes.map(item => {
        if (item.children) {
          return item.children.map(_ => `${item.path}/${_.path}`)
        } else {
          return []
        }
      })
      accessRoutesPath = Array.from(new Set(accessRoutesPath.reduce((acc, val) => acc.concat(val), [])))
      this.$store.state.tagsView.visitedViews.forEach(element => {
        if (!accessRoutesPath.includes(element.path.replace(/\d/g, ''))) {
          this.$store.dispatch('tagsView/delView', element)
          if (this.$route.path === element.path) {
            this.$router.push('/')
          }
        }
      })
    },
    nativeLogin() {
      this.$store.dispatch('user/resetToken').then(() => {
        this.$router.push('/login')
        location.reload(true)
      })
      close()
    },
    close() {
      this.$store.dispatch('user/resetLoginDialog', false)
      this.codeNumber = 0
      this.loading = false
      clearInterval(this.sI)
    }
  }
}
</script>

<style lang="scss">
.dialog-reset-login{
  .el-dialog__body{
    padding: 10px 20px 0 20px
  }
}
</style>
